var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful-module-spacing.j2"] = require( "macros/contentful-module-spacing.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/recommendations-container.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful-module-spacing.j2", false, "core/templates/contentful/recommendations-container.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("getBottomMarginClasses")) {
var t_4 = t_1.getBottomMarginClasses;
} else {
cb(new Error("cannot import 'getBottomMarginClasses'")); return;
}
context.setVariable("getBottomMarginClasses", t_4);
var t_5;
t_5 = (lineno = 2, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.value[0]"]));
frame.set("recPlacementId", t_5, true);
if(frame.topLevel) {
context.setVariable("recPlacementId", t_5);
}
if(frame.topLevel) {
context.addExport("recPlacementId", t_5);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "recPlacementId")) {
output += "\n    ";
var t_6;
t_6 = env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "recPlacementId"),".","__");
frame.set("recPlacementKey", t_6, true);
if(frame.topLevel) {
context.setVariable("recPlacementKey", t_6);
}
if(frame.topLevel) {
context.addExport("recPlacementKey", t_6);
}
output += "\n    ";
var t_7;
t_7 = (lineno = 6, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"sys.contentType.sys.id"]));
frame.set("entryId", t_7, true);
if(frame.topLevel) {
context.setVariable("entryId", t_7);
}
if(frame.topLevel) {
context.addExport("entryId", t_7);
}
output += "\n    ";
var t_8;
t_8 = (lineno = 7, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.pageSize"]));
frame.set("tileCount", t_8, true);
if(frame.topLevel) {
context.setVariable("tileCount", t_8);
}
if(frame.topLevel) {
context.addExport("tileCount", t_8);
}
output += "\n    <div class=\"dom-rr-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "recPlacementKey"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "entryId") != "componentProductGrid"?(lineno = 8, colno = 64, runtime.callWrap(t_4, "getBottomMarginClasses", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entryloop")),"last")])):""), env.opts.autoescape);
output += "\" data-index=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleIndex"), env.opts.autoescape);
output += ">\n        <span\n            class=\"dom-rr-container\"\n            data-rr-placement=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "recPlacementId"), env.opts.autoescape);
output += "\"\n            data-tile-count=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tileCount"), env.opts.autoescape);
output += "\"\n            data-is-dy=\"true\"\n        >\n        ";
output += "\n    </div>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/recommendations-container.j2"] , dependencies)